import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { FileText, Megaphone, ExternalLink } from "lucide-react";
import { STATUS_CLS } from "@/pages/ContentHub";

export const useContentQueue = (wsId) => {
  const [items, setItems] = useState([]);
  useEffect(() => { if (wsId) api.get(`/content-queue?workspace_id=${wsId}`).then((r) => setItems(r.data)).catch(() => setItems([])); }, [wsId]);
  return items;
};

export const contentForDay = (items, cursor, day) => {
  if (!day) return [];
  return items.filter((it) => {
    const dt = new Date(it.scheduled_publish_date);
    return dt.getFullYear() === cursor.getFullYear() && dt.getMonth() === cursor.getMonth() && dt.getDate() === day;
  });
};

export const DayContentMarks = ({ items }) => {
  if (!items.length) return null;
  const blogs = items.filter((i) => i.format_type === "blog_article").length;
  const ads = items.length - blogs;
  return (
    <div className="flex gap-1 mt-1 text-[9px] font-mono">
      {blogs > 0 && <span className="inline-flex items-center gap-0.5 rounded bg-primary/15 text-primary px-1" data-testid="calendar-blog-mark"><FileText className="h-2.5 w-2.5" />{blogs > 1 ? blogs : ""}</span>}
      {ads > 0 && <span className="inline-flex items-center gap-0.5 rounded bg-violet-500/15 text-violet-300 px-1" data-testid="calendar-ppc-mark"><Megaphone className="h-2.5 w-2.5" /></span>}
    </div>
  );
};

export const DayContentList = ({ items }) => {
  const navigate = useNavigate();
  if (!items.length) return null;
  return (
    <div className="space-y-2 mb-3" data-testid="calendar-content-list">
      {items.map((it) => (
        <button key={it.id} onClick={() => navigate(it.campaign_id ? `/content?campaign=${it.campaign_id}` : "/content")}
          className="w-full text-left rounded-lg border border-primary/30 bg-primary/5 p-3 hover:border-primary/60 transition-colors" data-testid={`calendar-content-${it.id}`}>
          <div className="flex items-center justify-between gap-2">
            <span className="text-[10px] uppercase tracking-wider text-primary flex items-center gap-1">
              {it.format_type === "ppc_ad" ? <><Megaphone className="h-3 w-3" /> PPC launch</> : <><FileText className="h-3 w-3" /> Blog article</>}
            </span>
            <span className={`text-[10px] border rounded px-1.5 py-0.5 ${STATUS_CLS[it.status] || ""}`}>{(it.status || "").replace(/_/g, " ")}</span>
          </div>
          <p className="text-sm mt-1 line-clamp-2">{it.article_title || it.target_keyword}</p>
          {(it.shopify_url || it.inapp_url) && <span className="text-[11px] text-primary inline-flex items-center gap-1 mt-1"><ExternalLink className="h-3 w-3" /> live</span>}
        </button>
      ))}
    </div>
  );
};
